import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TopBar from "../components/TopBar";
import ToggleSwitch from "../components/ToggleSwitch";
import { ReactComponent as BackIcon } from "../assets/icon_back.svg";
import Colors from "../constants/Colors";
import { getSenderProfile, setSenderProfile } from "../utils/invoiceSenderProfile";
import {
  CURRENCY_CODES,
  getCurrency,
  setCurrency,
  getHourlyRate,
  setHourlyRate,
  getAiHourlyRate,
  setAiHourlyRate,
  isAiInvoiceEnabled,
  setAiInvoiceEnabled,
} from "../utils/billingRateSetting";

function InvoiceSettingsScreen() {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(getSenderProfile());
  const [currency, setCurrencyState] = useState(getCurrency());
  const [rate, setRate] = useState(String(getHourlyRate()));
  const [aiRate, setAiRate] = useState(String(getAiHourlyRate()));
  const [aiEnabled, setAiEnabled] = useState(isAiInvoiceEnabled());
  const [saved, setSaved] = useState(false);

  const setP = (patch) => {
    setProfile((p) => ({ ...p, ...patch }));
    setSaved(false);
  };

  const handleSave = () => {
    setSenderProfile(profile);
    setCurrency(currency);
    setHourlyRate(rate);
    setAiHourlyRate(aiRate);
    setAiInvoiceEnabled(aiEnabled);
    setSaved(true);
  };

  return (
    <div style={styles.container}>
      <TopBar
        leftContainer={
          <button onClick={() => navigate("/invoice")} style={styles.backBtn} aria-label="Back">
            <BackIcon style={{ width: 22, height: 22, fill: "var(--text)" }} />
          </button>
        }
        centerContainer={<span style={styles.headerTitle}>Invoice settings</span>}
      />
      <div style={styles.body}>
        <div style={styles.section}>FROM (your details)</div>
        <input style={styles.input} placeholder="Name / business" value={profile.name} onChange={(e) => setP({ name: e.target.value })} />
        <input style={styles.input} placeholder="Address" value={profile.address} onChange={(e) => setP({ address: e.target.value })} />
        <input style={styles.input} placeholder="Phone" value={profile.phone} onChange={(e) => setP({ phone: e.target.value })} />

        <div style={styles.section}>BANK</div>
        <input style={styles.input} placeholder="Bank SWIFT / Routing" value={profile.bankSwift} onChange={(e) => setP({ bankSwift: e.target.value })} />
        <input style={styles.input} placeholder="Bank name" value={profile.bankName} onChange={(e) => setP({ bankName: e.target.value })} />
        <input style={styles.input} placeholder="Bank address" value={profile.bankAddress} onChange={(e) => setP({ bankAddress: e.target.value })} />
        <input style={styles.input} placeholder="Account number" value={profile.accountNumber} onChange={(e) => setP({ accountNumber: e.target.value })} />
        <input style={styles.input} placeholder="Beneficiary name" value={profile.beneficiaryName} onChange={(e) => setP({ beneficiaryName: e.target.value })} />

        <div style={styles.section}>BILLING</div>
        <label style={styles.label}>Currency</label>
        <select style={styles.input} value={currency} onChange={(e) => { setCurrencyState(e.target.value); setSaved(false); }}>
          {CURRENCY_CODES.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
        <label style={styles.label}>Hourly rate (human)</label>
        <input style={styles.input} inputMode="decimal" value={rate} onChange={(e) => { setRate(e.target.value.replace(/[^0-9.]/g, "")); setSaved(false); }} />
        <label style={styles.label}>Hourly rate (AI)</label>
        <input style={styles.input} inputMode="decimal" value={aiRate} onChange={(e) => { setAiRate(e.target.value.replace(/[^0-9.]/g, "")); setSaved(false); }} />
        <div style={styles.toggleRow}>
          <span>Bill AI-tracked time</span>
          <ToggleSwitch
            checked={aiEnabled}
            onChange={(next) => { setAiEnabled(next); setSaved(false); }}
          />
        </div>
      </div>

      <div style={styles.ctaBar}>
        <button style={styles.primaryCta} onClick={handleSave}>{saved ? "Saved ✓" : "Save"}</button>
      </div>
    </div>
  );
}

const styles = {
  container: { paddingTop: "50px", height: "calc(100vh - 60px)", boxSizing: "border-box" },
  backBtn: { background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", padding: 0 },
  headerTitle: { fontWeight: 700 },
  body: { padding: "16px", paddingBottom: "90px", maxWidth: "560px", margin: "0 auto", height: "100%", overflowY: "auto", boxSizing: "border-box" },
  section: { fontSize: "11px", fontWeight: 700, color: "var(--text-muted)", letterSpacing: "0.5px", margin: "18px 0 8px" },
  label: { fontSize: "12px", color: "var(--text-muted)", margin: "8px 0 4px", display: "block" },
  input: { padding: "10px", borderRadius: "8px", border: "1px solid var(--border)", background: "var(--surface)", color: "var(--text)", fontSize: "14px", width: "100%", boxSizing: "border-box", marginBottom: "8px" },
  toggleRow: { display: "flex", alignItems: "center", justifyContent: "space-between", color: "var(--text)", fontSize: "14px", padding: "10px 0" },
  ctaBar: { position: "fixed", left: 0, right: 0, bottom: "60px", padding: "12px 16px", background: "var(--bg)", borderTop: "1px solid var(--border)", boxSizing: "border-box" },
  primaryCta: { width: "100%", padding: "12px", background: Colors.primary, color: "#fff", border: "none", borderRadius: "10px", fontWeight: 700, cursor: "pointer" },
};

export default InvoiceSettingsScreen;
